import {
  BrandCTAButton,
  BrandFooter,
  BrandFooterHeadline,
  BrandFooterLabel,
  BrandFooterSub,
} from './SurveyParticipantPageStyles'

/**
 * Marketing footer shown on participant-facing terminal states (thank-you,
 * closed survey). Promotes Bandos to people who arrived via a shared link.
 */
export function SurveyBrandFooter() {
  return (
    <BrandFooter>
      <BrandFooterLabel>Built with Bandos</BrandFooterLabel>
      <BrandFooterHeadline>Have ideas you want to validate?</BrandFooterHeadline>
      <BrandFooterSub>
        Stress-test your idea, define your customer, and find the real opportunity — before writing
        a single line of code.
      </BrandFooterSub>
      <BrandCTAButton href="https://bandos.ai" target="_blank" rel="noopener noreferrer">
        Try Bandos free →
      </BrandCTAButton>
    </BrandFooter>
  )
}
